
import Vue from "vue";
import { CashDro, } from "@/plugins/cashdro/cashdro";
export default Vue.extend({
	data() {
		return {
			timer: 0,
			total: 0,
			payed: 0,
			returned: 0,
			screenUrl: CashDro.getScreenUrl()
		};
	},
	props: {
		operation: String,
		amount: Number,
		screenOnly: Boolean
	},
	methods: {
		async cancel(){
			await CashDro.cancel(this.operation);
			this.$emit("close");
		},
		async initPayment(){
			let res = await CashDro.acknowledge(this.operation);
			if (res.code == 1){
				let _ = this;
				this.timer = setInterval(async function () {
					let res = await CashDro.ask(_.operation);
					let r = JSON.parse((res.data)) as any;
					let totalIn = Number(r.operation.totalin);
					let totalOut = Math.abs(Number(r.operation.totalout));
					_.total = r.operation.total / 100;
					_.payed = totalIn / 100;
					_.returned = totalOut / 100;

					// Check if CashDro returned all the inserted money
					if (totalIn > 0 && totalIn === totalOut) {
						// This case indicates that the machine returned all inserted money
						console.error("CashDro could not process the operation due to insufficient funds.");
						_.$emit("error", _.$ct("errors.insufficient-funds").toString());
						return; // Exit early as the operation failed
					}

					if(r.operation.state=="F"){
						clearInterval(_.timer);
						let actualPayed = (totalIn - totalOut) / 100;
						if(actualPayed > 0){
							_.$emit("succes", actualPayed);
						}else{
							_.$emit("close");
						}
					}
				}, 1000);
			}
		}
	},
	beforeDestroy() {
		clearInterval(this.timer);
	},
	mounted(){
		this.total = this.amount;
		if(!this.screenOnly){
			this.initPayment();
		}
	},
	i18nEx: {
		componentPrefix: "components.sales.CashierRefund.CashDro"
	},
});
